import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=326fc2f2&scoped=true&lang=html&"
import script from "./BoxList.vue?vue&type=script&lang=js&"
export * from "./BoxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326fc2f2",
  null
  
)

export default component.exports